import { useCallback } from 'react'
import { ApiErrorInterface, ApiErrorTypes } from 'ogram-react'

import { useMutation, useStore } from './mst-hooks'

type AcceptApplicantConfig = {
  isPermanentJob: boolean
  onAccepted?: () => void
  onAcceptFailed?: (err: ApiErrorInterface) => void
  onRejected?: () => void
  onRejectFailed?: (err: ApiErrorInterface) => void
}

type TemporaryJobParams = {
  job_id: number
  sp_id: string
  shift_ids?: number[]
}

type PermanentJobParams = {
  job_application_id: number
}

export function useAcceptApplicant({
  isPermanentJob,
  onAccepted,
  onAcceptFailed,
  onRejected,
  onRejectFailed,
}: AcceptApplicantConfig) {
  const { data } = useStore()

  const acceptAction = useCallback(
    (params: TemporaryJobParams | PermanentJobParams) => {
      if (isPermanentJob) {
        return data.acceptApplicantOfPermanentJob(params as PermanentJobParams)
      } else {
        return data.acceptApplicantApiCall(params as TemporaryJobParams)
      }
    },
    [isPermanentJob, data],
  )

  const rejectAction = useCallback(
    (params: TemporaryJobParams | PermanentJobParams) => {
      if (isPermanentJob) {
        return data.rejectApplicantOfPermanentJob(params as PermanentJobParams)
      } else {
        return data.rejectApplicantApiCall(params as TemporaryJobParams)
      }
    },
    [isPermanentJob, data],
  )

  const [acceptQuery, acceptApplicant] = useMutation(acceptAction, {
    onSuccess: onAccepted,
    onError: onAcceptFailed,
    filterError: [ApiErrorTypes.ClientError],
  })
  const [rejectQuery, rejectApplicant] = useMutation(rejectAction, {
    onSuccess: onRejected,
    onError: onRejectFailed,
    filterError: [ApiErrorTypes.ClientError],
  })

  return {
    acceptQuery,
    rejectQuery,
    acceptApplicant,
    rejectApplicant,
  }
}
